"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect = exports.MasterDataFieldsEffect = exports.effectDataFieldsEffect = exports.DateTimeUtcFromStringEffect = exports.PartialMasterDataDatabaseSchemaEffect = exports.PartialMasterDataSchemaEffect = exports.MasterDataSchemaEffect = exports.masterDataDBKeysEffect = exports.masterDataKeysEffect = exports.encodeRequestObject = exports.decodeRequestOject = exports.mapToMasterDataRecord = exports.mapToMasterDataDBRecord = exports.masterDataKeys = exports.masterDataDBKeys = exports.masterDataInformationFields = exports.RequestQueryFieldsCodec = void 0;
const E = __importStar(require("fp-ts/Either"));
const function_1 = require("fp-ts/function");
const validation_1 = require("@bloodline-packages/bloodline/dist/validation");
const backend_fields_1 = require("./generated/backend-fields");
Object.defineProperty(exports, "mapToMasterDataDBRecord", { enumerable: true, get: function () { return backend_fields_1.mapToMasterDataDBRecord; } });
Object.defineProperty(exports, "mapToMasterDataRecord", { enumerable: true, get: function () { return backend_fields_1.mapToMasterDataRecord; } });
Object.defineProperty(exports, "masterDataDBKeys", { enumerable: true, get: function () { return backend_fields_1.masterDataDBKeys; } });
Object.defineProperty(exports, "masterDataKeys", { enumerable: true, get: function () { return backend_fields_1.masterDataKeys; } });
const types_1 = require("./types");
var types_2 = require("./types");
Object.defineProperty(exports, "RequestQueryFieldsCodec", { enumerable: true, get: function () { return types_2.RequestQueryFieldsCodec; } });
var defined_data_fields_1 = require("./defined-data-fields");
Object.defineProperty(exports, "masterDataInformationFields", { enumerable: true, get: function () { return defined_data_fields_1.masterDataInformationFields; } });
exports.decodeRequestOject = (0, function_1.flow)(types_1.RequestQueryFieldsCodec.decode, E.mapLeft((0, validation_1.toValidationError)('Invalid request object')));
exports.encodeRequestObject = types_1.RequestQueryFieldsCodec.encode;
var effect_1 = require("./effect");
Object.defineProperty(exports, "masterDataKeysEffect", { enumerable: true, get: function () { return effect_1.masterDataKeys; } });
Object.defineProperty(exports, "masterDataDBKeysEffect", { enumerable: true, get: function () { return effect_1.masterDataDBKeys; } });
Object.defineProperty(exports, "MasterDataSchemaEffect", { enumerable: true, get: function () { return effect_1.MasterDataSchema; } });
Object.defineProperty(exports, "PartialMasterDataSchemaEffect", { enumerable: true, get: function () { return effect_1.PartialMasterDataSchema; } });
Object.defineProperty(exports, "PartialMasterDataDatabaseSchemaEffect", { enumerable: true, get: function () { return effect_1.PartialMasterDataDatabaseSchema; } });
Object.defineProperty(exports, "DateTimeUtcFromStringEffect", { enumerable: true, get: function () { return effect_1.DateTimeUtcFromString; } });
Object.defineProperty(exports, "effectDataFieldsEffect", { enumerable: true, get: function () { return effect_1.effectDataFields; } });
Object.defineProperty(exports, "MasterDataFieldsEffect", { enumerable: true, get: function () { return effect_1.MasterDataFields; } });
exports.Effect = __importStar(require("./effect"));
//# sourceMappingURL=index.js.map